import React, { useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import { Grid } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { ButtonText } from "@loanbossinc/component-library";

import { PaddedWrapper, RentContainer, RentRow, StyledHeaderName, RowContainer } from "./styles";

const ChargeTypeRow = props => {
  const { chargeGroup, chargeCodeNickname, onEditType, onDeleteType, areLeaseDatesValid } = props;
  const { charges } = chargeGroup;
  const earliestStartDate = _.orderBy(charges, c => moment(c.startDate), "asc")[0]?.startDate;
  const latestEndDate = _.orderBy(charges, c => moment(c.endDate), "desc")[0]?.endDate;
  const leaseDates = `${moment.utc(earliestStartDate).format("MM/DD/YY")} - ${moment.utc(latestEndDate).format("MM/DD/YY")}`;

  return (
    <RentContainer style={{ position: "relative" }}>
      <RentRow w="40%" align="start">
        {chargeCodeNickname}
      </RentRow>
      <RentRow w="40%" align="start">
        {leaseDates}
      </RentRow>
      <RentRow w="20%" align="right">
        {areLeaseDatesValid && (
          <EditIcon style={{ cursor: "pointer", color: "#005AA9" }} onClick={onEditType} />
        )}
        <DeleteIcon style={{ marginLeft: "0.5em", cursor: "pointer", color: "#005AA9" }} onClick={onDeleteType} />
      </RentRow>
    </RentContainer>
  );
};

const ChargeScheduleTypes = props => {
  const { leaseState, setLeaseState, chargeSchedules, setRentRollsSelections } = props;

  useEffect(() => {
    const grouped = _.chain(chargeSchedules).groupBy("chargeCode").map((charges, chargeCode) => ({ chargeCode, charges })).value();
    setLeaseState(prev => ({ ...prev, groupedChargeSchedules: grouped }));
  }, [chargeSchedules]);

  const onAddNewType = () => {
    setRentRollsSelections({
      isEditingChargeSchedule: true
    });
  };

  const onEditType = chargeGroup => {
    setRentRollsSelections({
      isEditingChargeSchedule: true
    });
    setLeaseState(prev => ({ ...prev, selectedChargeScheduleGroup: chargeGroup }));
  };

  const onDeleteType = chargeGroup => {
    const filteredCharges = leaseState.rentsAndCharges?.filter(charge => charge.chargeCode !== chargeGroup.chargeCode);
    const filteredAliases = leaseState.editedChargeCodeAliases?.filter(alias => alias.chargeCode !== chargeGroup.chargeCode);
    setLeaseState(prev => ({ ...prev, rentsAndCharges: filteredCharges, editedChargeCodeAliases: filteredAliases, isAnythingWasUpdated: true }));
  };

  const areLeaseDatesValid = Boolean(leaseState.leaseStartDate) && Boolean(leaseState.leaseEndDate);

  const getGroupChargeCodeNickname = chargeGroup => {
    const existingAliasObj = leaseState.editedChargeCodeAliases?.find(alias => alias.chargeCode === chargeGroup.chargeCode);

    return existingAliasObj ? existingAliasObj.alias : chargeGroup.chargeCode;
  };

  return (
    <RowContainer>
      <Grid container justify="flex-start" style={{ marginBottom: "10px" }} alignItems="center" direction="row">
        <Grid item xs={12}>
          <PaddedWrapper>
            <StyledHeaderName>CHARGE SCHEDULES</StyledHeaderName>
          </PaddedWrapper>
        </Grid>
        <Grid item xs={12}>
          <PaddedWrapper>
            <RentContainer header style={{ marginTop: "1em" }}>
              <RentRow w="40%" align="start" bold>
                CHARGE TYPE NICKNAME
              </RentRow>
              <RentRow w="40%" align="start" bold>
                DATE RANGE
              </RentRow>
              <RentRow w="20%" align="right" bold>
                <ButtonText
                  label={<div>Add new type</div>}
                  onClick={onAddNewType}
                  disabled={!areLeaseDatesValid}
                />
              </RentRow>
            </RentContainer>
          </PaddedWrapper>
        </Grid>
        <Grid item xs={12}>
          <PaddedWrapper>
            {leaseState.groupedChargeSchedules?.map(chargeGroup => (
              <ChargeTypeRow
                chargeGroup={chargeGroup}
                chargeCodeNickname={getGroupChargeCodeNickname(chargeGroup)}
                key={chargeGroup.chargeCode}
                leaseState={leaseState}
                onEditType={() => onEditType(chargeGroup)}
                onDeleteType={() => onDeleteType(chargeGroup)}
                areLeaseDatesValid={areLeaseDatesValid}
              />
            ))}
          </PaddedWrapper>
        </Grid>
      </Grid>
    </RowContainer>
  );
};

export default ChargeScheduleTypes;
